import { DropdownOption } from '@anytag/shared-types';
import { cn } from '@anytag/shared-utils';
import { TextCutter } from '../TextCutter';
import { MultiLevelMenu } from './MultiLevelMenu';
import { DropdownDefaultProps } from './types';

export interface DropdownMenuDefaultProps<T extends DropdownOption> extends DropdownDefaultProps<T> {
  onSelectOption?: (option: T) => void;
}

export const DropdownMenuDefault = <T extends DropdownOption>({
  options,
  className,
  onSelectOption
}: DropdownMenuDefaultProps<T>) => (
  <div className={cn(styles.dropdownWrapper, className)}>
    {options.map((option, index) => {
      const { label, gtmId, active, disabled, className } = option;

      return option.menuType === 'multi-level' ? (
        <MultiLevelMenu
          key={index}
          value={option.value}
          label={option.label}
          submenu={option.submenu}
          onClickSubmenu={(o) => onSelectOption?.(o as T)}
        />
      ) : (
        <div
          id={gtmId}
          key={index}
          className={cn(styles.dropdownItem(active, disabled), className)}
          onClick={() => (!disabled ? onSelectOption?.(option) : undefined)}
        >
          {typeof label === 'string' ? <TextCutter text={label} /> : label}
        </div>
      );
    })}
  </div>
);

const styles = {
  dropdownWrapper: cn('z-10 box-border w-max max-w-87.5 min-w-41.25 rounded-sm bg-white p-2'),
  dropdownItem: (active?: boolean, disabled?: boolean) =>
    cn(
      'flex cursor-pointer items-center bg-white p-2.5 text-sm normal-case transition-[background-color] duration-100',
      {
        'cursor-default': disabled,
        'bg-black-10': active,
        'hover:bg-menu-item-hover': !disabled
      }
    )
};
